import { internalApiClient } from '@/shared/api-client/internal-api-client';

export async function downloadPostsForScrapingJob(scrapingJobId: string) {
  try {
    const response = await internalApiClient.get(
      `social-post-scraping-jobs/${scrapingJobId}/export`,
    );

    // Get the response as text (CSV data)
    const csvData = await response.text();

    // Create a blob with the CSV data
    const blob = new Blob([csvData], { type: 'text/csv' });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = `scraping-posts-${scrapingJobId}.csv`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download posts:', error);
    throw error; // Re-throw to handle in component
  }
}
